import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'pay-button-primary',
  imports: [NgClass],
  templateUrl: './button-primary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonPrimaryComponent {
  readonly disabled = input<boolean>(false);
  readonly type = input('submit');
  readonly loading = input<boolean>(false);
  readonly rounded = input<string>('rounded-4xl');
}
